import { stessaSostanza } from './testo-nudo.util';

/** Perche' la formattazione non e' stata applicata. */
export type MotivoFormattazione = 'alterato' | 'vuoto';

export class ErroreFormattazione extends Error {
  constructor(readonly motivo: MotivoFormattazione) {
    super(motivo);
    this.name = 'ErroreFormattazione';
  }
}

const TENTATIVI = 3;

/**
 * Chiede la formattazione e la accetta solo se le parole sono rimaste quelle.
 *
 * Il modello ogni tanto sbaglia la copia: cancella un intertitolo, corregge un
 * refuso, salta un blocco. Succede in meno di un caso su dieci e non si ripete
 * sullo stesso articolo, quindi vale la pena richiedere la formattazione invece
 * di rimandare il lavoro alla redazione. Un errore della chiamata, invece, non
 * e' un difetto della risposta e passa subito a chi ha chiamato.
 */
export async function formattaConTentativi(
  testoOriginale: string,
  chiama: (tentativo: number) => Promise<any>,
  opzioni: { onTentativo?: (tentativo: number) => void } = {}
): Promise<string> {
  let ultimoMotivo: MotivoFormattazione = 'vuoto';

  for (let tentativo = 1; tentativo <= TENTATIVI; tentativo++) {
    if (tentativo > 1) {
      opzioni.onTentativo?.(tentativo);
    }
    const risposta = await chiama(tentativo);
    const formattato: unknown = risposta?.result;

    if (typeof formattato !== 'string' || formattato.trim().length === 0) {
      ultimoMotivo = 'vuoto';
      continue;
    }
    if (!stessaSostanza(testoOriginale, formattato)) {
      ultimoMotivo = 'alterato';
      continue;
    }
    return formattato;
  }

  throw new ErroreFormattazione(ultimoMotivo);
}
